module.exports = __webpack_public_path__ + "static/media/pending-indicator-black.2dbc5b3d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pending-indicator-black.svg
// module id = ./src/assets/images/pending-indicator-black.svg
// module chunks = 0